'use strict';
var React = require('react');
var ReactDOM = require('react-dom');
var _ = require('underscore');
var appTypes = require('../../types/appTypes');
var styleHelper = require('../../helper/styleHelper');
var propConst = require('../../constants/propConst');
/*
 @Author : mengxiaojiang
 @CreateDate : 2016-4-1
 @Descript : 内容面板组件
 */
var ContentPanel = React.createClass({
  getInitialState: function () {
    return {

    };
  },

  //记得补充透明度
  render: function () {
    var w = styleHelper.getWidth(this.props);
    var h = styleHelper.getHeight(this.props);
    var style = {
      clip: 'rect(1 ' + (w - 1) + ' ' + (h - 1) + ' 1)',
      border:'none',
      // visibility : styleHelper.getVisible(this)?'visible':'hidden'
    };
    styleHelper.StyleUtil(this.props).background().base().bounds().default(style);
    return (
      <div
        className={"component component-" + this.props.controlTypeID}
        key={this.props.controlID}
        id={this.props.controlID}
        style={style}>
        {
          this.props.children
        }
      </div>
    )
  },

  componentDidUpdate : function(){
    var index = this.props.selectedIndex;
    if(this.props.currentIndex !== undefined) {
      index = this.props.currentIndex;
    }
    this.initSelected(index);
    this.doBindEvent();
  },

  componentDidMount: function () {
    var index = parseInt(styleHelper.getInt(this.props, propConst.SELECTED_INDEX), 10);
    this.initSelected(index);
    this.doBindEvent();

    this.loadedInteractiveIndexArray = [];
    this.loadedInteractiveIndexArray.push(index);
  },

  startLoadInteractive: function(index) {
    if(this.props.events &&
      this.props.events.startCompLoadInteractive &&
      this.loadedInteractiveIndexArray.indexOf(index) === -1) {
      this.loadedInteractiveIndexArray.push(index);
      this.props.events.startCompLoadInteractive(this.props.items[index]);
    }
  },

  doBindEvent : function(){
    $(ReactDOM.findDOMNode(this)).off('onSwitch');
    $(ReactDOM.findDOMNode(this)).on('onSwitch', this.onSwitch);
  },

  loadedInteractiveIndexArray: [],
  onSwitch: function (event, controlID, currentIndex, nextIndex, complete) {
    var dom;
    var targetDom;
    var isReloadInteractive = false;
    var currentDom;
    var w;
    var targetOption;
    var currentOption;
    var aniType;
    var duration = 200;
    var self = this;
    var finish = function () {
      $(currentDom).css({opacity: 1, display: 'none'});
      $(targetDom).css({opacity: 1, dispatch: 'block'});
      if (complete) {
        complete();
      }
      if(isReloadInteractive) {      //需要重新加载交互情况下执行下方
        // $(currentDom).css({display: 'none', visibility: 'hidden'});
        $(currentDom).css({display: 'none'});
        self.startLoadInteractive(nextIndex);
      }
    };
    if (controlID === this.props.controlID) {

      dom = ReactDOM.findDOMNode(this);
      if(_.isUndefined(nextIndex) || _.isUndefined(currentIndex)){
        if(complete){
          complete();
        }
        return;
      }
      if(nextIndex > dom.children.length - 1){
        if(complete){
          complete();
        }
        return;
      }

      currentDom = dom.children[currentIndex];
      targetDom = dom.children[nextIndex];
      if(currentIndex === nextIndex){
        finish();
        return;
      }
      isReloadInteractive = true;
      w = styleHelper.getWidth(this.props);
      targetOption = {
        queue: false,
        duration: duration,
        complete: finish
      };
      currentOption = {
        queue: false,
        duration: duration
      };
      aniType = styleHelper.getPropertyValue(this.props, propConst.ANI_TYPE);
      switch (aniType) {
        case appTypes.StackPanelAniType.FADE:
          $(currentDom).animate({opacity: 0}, currentOption);
          $(targetDom).css({opacity: 0,display: 'block'});
          $(targetDom).animate({opacity: 1}, targetOption);
          break;
        case appTypes.StackPanelAniType.PUSH:
          $(currentDom).css({zIndex:1}).animate({left: -currentDom.clientWidth}, currentOption);
          $(targetDom).css({left: w, display: 'block',zIndex:2}).animate({left: 0}, targetOption);
          break;
        case appTypes.StackPanelAniType.SLIDE:
          $(currentDom).css({zIndex:1});
          $(targetDom).css({left: w, display: 'block',zIndex:2}).animate({left: 0}, targetOption);
          break;
        default:

          $(targetDom).css({display: 'block',zIndex:1});
          finish();
          break;
      }
    }
  },

  initSelected: function (selIndex) {
    if(selIndex === undefined) {
      return;
    }
    var dom = ReactDOM.findDOMNode(this);
    var list = dom.children;
    var i;
    var display;
    for (i = 0; i < list.length; i++) {
      if (i === selIndex) {
        display = 'block';
      } else {
        display = 'none';
      }
      $(list[i]).css({display: display});
    }
  }
});


module.exports = ContentPanel;



// WEBPACK FOOTER //
// ./src/views/Components/ContentPanel.jsx